import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Button from "@/atomic/atoms/Button";
import { InputMask } from "@react-input/mask";
import { Link } from "react-router-dom";

export default function RegisterView({
  goBack,
  isDisabled,
  activeStep,
  goToNextStep,
  jumpSteps,
  goToBeforeStep,
  errors,
  register,
  handleSubmit,
  watch,
  setValue,
}: PropsView) {
  const watchedValues = watch();
  const isAcceptedTerms = watchedValues.isAcceptedTerms;

  const toggleTerms = () => {
    setValue("isAcceptedTerms", !isAcceptedTerms);
  };

  return (
    <div className="h-full relative">
      <Header
        title="Dados Pessoais"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form">
        <form className="h-full flex flex-col justify-between w-[calc(480px)]" onSubmit={handleSubmit}>
          <div>
            <h2 className="mt-6 text-black text-xl">Vamos começar</h2>
            <div className="flex flex-col justify-center">
              <input
                {...register("name")}
                required
                type="text"
                name="name"
                placeholder="Nome completo"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.name && (
                <span className="text-red-500 text-xs">{errors.name.message as string}</span>
              )}
              <InputMask
                {...register("document")}
                required
                type="text"
                name="document"
                inputMode="numeric"
                mask="___.___.___-__"
                replacement={{ _: /\d/ }}
                placeholder="CPF"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.document && (
                <span className="text-red-500 text-xs">{errors.document.message as string}</span>
              )}
              <input
                {...register("email")}
                required
                type="text"
                name="email"
                placeholder="E-mail"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.email && (
                <span className="text-red-500 text-xs">{errors.email.message as string}</span>
              )}
              <InputMask
                {...register("phone")}
                required
                type="text"
                name="phone"
                inputMode="numeric"
                mask="(__) _____-____"
                replacement={{ _: /\d/ }}
                placeholder="Celular"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.phone && (
                <span className="text-red-500 text-xs">{errors.phone.message as string}</span>
              )}
              <div className='flex flex-col items-start justify-start mt-4 w-full'>
                <label className="flex items-center cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={isAcceptedTerms}
                    onChange={toggleTerms}
                    className="w-6 h-6 accent-black mr-2 mt-1"
                  />
                  <div className='flex flex-1'>
                    <span className="text-sm text-black">
                      Aceito os <Link to="/terms" className="underline italic text-gray-500">Termos de Uso</Link> e <Link to="/policy" className="underline italic text-gray-500">Política de Privacidade</Link>.
                    </span>
                  </div>
                </label>
                {errors.isAcceptedTerms && (
                  <span className="text-red-500 text-xs">{errors.isAcceptedTerms.message as string}</span>
                )}
              </div>
            </div>
          </div>
          <Button
            title="Continuar"
            type="submit"
            isDisabled={isDisabled}
          />
        </form>
      </main>
      {activeStep < 2 && <div className={`p-8 fixed flex flex-col flex-1 top-0 left-0 right-0 bottom-0 z-30 w-full bg-black justify-between items-start text-black h-full min-h-screen ${activeStep === 0 ? "bg-onboarding1" : "bg-onboarding2"} bg-cover bg-fixed bg-center transition-all duration-500 ease-in-out`}>
        <div className="w-full md:max-w-7xl md:mx-auto flex items-center justify-between">
          <button onClick={goToBeforeStep} className="text-white">
            <img
              src="/icon-arrow-left-white.png"
              height={24}
              width={24}
            />
          </button>
          <button onClick={jumpSteps} className="text-white">
            Pular
          </button>
        </div>
        <div className="w-full md:max-w-7xl md:mx-auto mb-[calc(80px)]">
          <div className="max-w-md">
            {activeStep === 0 && <h1 className="text-white text-3xl md:text-4xl mb-1 transition-all duration-300 ease-in-out font-bold">Siga viagem sem  <br/>perrengue, <span className="text-principal">sem parar<br/></span></h1>}
            {activeStep !== 0 && <h1 className="text-white text-3xl md:text-4xl mb-1 transition-all duration-300 ease-in-out font-bold">Pegue a estrada, <span className="text-principal">pague <br /> o pedágio no automático.</span></h1>}
            {activeStep === 0 && <h2 className="text-white text-lg md:text-xl mb-9 transition-all duration-300 ease-in-out mt-3 font-myFont">Consulta e gerenciamento de passagens pra você viver sua rotina com tranquilidade.</h2>}
            {activeStep !== 0 && <h2 className="text-white text-lg md:text-xl mb-9 transition-all duration-300 ease-in-out mt-3 font-myFont">Cobrança direto no cartão cadastrado. Rápido, seguro e sem surpresas.</h2>}
          </div>
          <div className="flex w-full items-end justify-between">
            <div className="flex items-center justify-start">
              <span
                className={activeStep === 0 ? "bg-white h-2 w-4 rounded-lg" : "bg-gray-400 h-2 w-2 rounded-lg"}
              />
              <span
                className={`ml-1 ${activeStep === 0 ? "bg-gray-400 h-2 w-2 rounded-lg" : "bg-white h-2 w-4 rounded-lg"}`}
              />
            </div>
            <button
              className="border border-white rounded-lg p-4 px-6 text-white"
              onClick={goToNextStep}>
              Próximo
            </button>
          </div>
        </div>
      </div>}
    </div>
  );
}
